import { useState } from "react";
import { ChevronDown } from "lucide-react";

export function Collapse({ title, defaultOpen = false, open: openProp, onOpenChange, children, testId }) {
  const [internal, setInternal] = useState(defaultOpen);
  const controlled = openProp !== undefined;
  const open = controlled ? openProp : internal;
  const toggle = () => { const n = !open; if (controlled) onOpenChange?.(n); else setInternal(n); };
  return (
    <div className="card-arch overflow-hidden" data-testid={testId}>
      <button onClick={toggle} data-testid={testId ? `${testId}-toggle` : undefined}
        className="w-full flex items-center justify-between gap-3 p-4 text-left">
        <span className="mono-label text-slate-400">{title}</span>
        <ChevronDown className={`h-4 w-4 text-slate-500 shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="px-4 pb-4 -mt-1">{children}</div>}
    </div>
  );
}
